import {
	type UseMutationOptions,
	useMutation,
	useQueryClient
} from '@tanstack/react-query'
import {
	httpRejectFinalReviewListing,
	type RejectFinalReviewListingOptions
} from '@/features/luxe-submissions/http/luxe-submissions.http'
import { errorHandler } from '@/helpers/utils'
import { FINAL_REVIEW_LISTINGS_QUERY_KEY } from './use-get-final-review-listings'
import { QUEUE_COUNTS_QUERY_KEY } from './use-get-queue-counts'

export const useRejectFinalReviewListing = (
	listingId: string,
	options?: Omit<
		UseMutationOptions<
			unknown,
			unknown,
			RejectFinalReviewListingOptions['payload']
		>,
		'mutationFn'
	>
) => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: (payload: RejectFinalReviewListingOptions['payload']) =>
			httpRejectFinalReviewListing({ urlParams: { listingId }, payload }),
		...options,
		onError: (error, variables, onMutateResult, context) => {
			errorHandler(error)
			options?.onError?.(error, variables, onMutateResult, context)
		},
		onSuccess: (...args) => {
			options?.onSuccess?.(...args)
			queryClient.invalidateQueries({
				queryKey: [FINAL_REVIEW_LISTINGS_QUERY_KEY]
			})
			queryClient.invalidateQueries({
				queryKey: [QUEUE_COUNTS_QUERY_KEY]
			})
		}
	})
}
